function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "bus");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bus"
}, /*#__PURE__*/React.createElement("polyline", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "2.69 35.05 13.26 35.03 13.26 25.19 6.48 25.19"
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 47.42,
  cy: 47.01,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  cx: 17.34,
  cy: 47.01,
  rx: 4.08,
  ry: 3.85
}), /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 19.44,
  y: 25.19,
  width: 11.78,
  height: 10.06,
  transform: "translate(50.67 60.43) rotate(-180)"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x: 37.03,
  y: 25.19,
  width: 11.78,
  height: 10.06,
  transform: "translate(85.84 60.43) rotate(-180)"
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "60.52 35.25 54.63 35.25 54.63 25.19 60.52 25.19"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M51.5,47h6a3,3,0,0,0,3-3v-22a3,3,0,0,0-3-3H10.68c-1.65,0-2.46,1.28-3,3l-1.2,3.11-3.8,9.87v9a3,3,0,0,0,3,3h7.58"
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 21.42,
  y1: 47.01,
  x2: 43.34,
  y2: 47.01
}), /*#__PURE__*/React.createElement("line", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  x1: 2.69,
  y1: 41.39,
  x2: 7.3,
  y2: 41.39
}));

var SvgBus1 = function SvgBus1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bus1.7a959334.svg";
export { ForwardRef as ReactComponent };